(function () {
  'use strict';

  function init(header) {
    if (header.dataset.sidizHeaderReady === 'true') return;
    header.dataset.sidizHeaderReady = 'true';
    var menu = document.querySelector('[data-sidiz-menu]');
    var overlay = document.querySelector('[data-sidiz-overlay]');
    var menuOpen = header.querySelector('[data-sidiz-menu-open]');
    var menuClose = menu && menu.querySelector('[data-sidiz-menu-close]');
    var search = document.querySelector('[data-sidiz-search]');
    var searchOpen = header.querySelector('[data-sidiz-search-open]');
    var searchClose = search && search.querySelector('[data-sidiz-search-close]');
    var sections = Array.prototype.slice.call(document.querySelectorAll('[data-header-scheme]'));

    function announcementOffset() {
      var bar = document.querySelector('.section-announcement-bar');
      if (!bar) return 0;
      var style = getComputedStyle(bar);
      if (style.display === 'none' || style.visibility === 'hidden') return 0;
      var rect = bar.getBoundingClientRect();
      return Math.max(0, Math.min(rect.height, rect.bottom));
    }
    function updateOffset() {
      document.documentElement.style.setProperty('--sidiz-announcement-height', announcementOffset() + 'px');
    }
    function applyScheme() {
      var band = announcementOffset() + header.offsetHeight / 2;
      var scheme = 'light';
      for (var i = 0; i < sections.length; i++) {
        var rect = sections[i].getBoundingClientRect();
        if (rect.top <= band && rect.bottom >= band) { scheme = sections[i].dataset.headerScheme; break; }
      }
      header.classList.toggle('header--on-dark', scheme === 'dark');
      header.classList.toggle('header--on-light', scheme !== 'dark');
      header.classList.toggle('header--scrolled', window.scrollY > 8);
    }

    var ticking = false;
    function update() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { updateOffset(); applyScheme(); ticking = false; });
    }
    function closeMenu() {
      if (!menu) return;
      menu.classList.remove('is-open');
      menu.setAttribute('aria-hidden', 'true');
      overlay.classList.remove('is-open');
      menuOpen.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('sidiz-nav-open');
    }
    function openMenu() {
      if (!menu) return;
      menu.classList.add('is-open');
      menu.setAttribute('aria-hidden', 'false');
      overlay.classList.add('is-open');
      menuOpen.setAttribute('aria-expanded', 'true');
      document.body.classList.add('sidiz-nav-open');
      if (menuClose) window.setTimeout(function () { menuClose.focus({ preventScroll: true }); }, 40);
    }
    function openSearch() {
      if (!search) return;
      closeMenu();
      if (typeof search.showModal === 'function') search.showModal(); else search.setAttribute('open', '');
      searchOpen.setAttribute('aria-expanded', 'true');
      document.body.classList.add('sidiz-nav-open');
      var input = search.querySelector('input[type="search"]');
      if (input) window.setTimeout(function () { input.focus(); }, 40);
    }
    function closeSearch() {
      if (!search) return;
      if (typeof search.close === 'function') search.close(); else search.removeAttribute('open');
      searchOpen.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('sidiz-nav-open');
      searchOpen.focus();
    }

    if (menuOpen) menuOpen.addEventListener('click', openMenu);
    if (menuClose) menuClose.addEventListener('click', closeMenu);
    if (overlay) overlay.addEventListener('click', closeMenu);
    if (searchOpen) searchOpen.addEventListener('click', openSearch);
    if (searchClose) searchClose.addEventListener('click', closeSearch);
    if (search) search.addEventListener('click', function (event) { if (event.target === search) closeSearch(); });
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      closeMenu();
      if (search && search.hasAttribute('open')) closeSearch();
    });
    document.addEventListener('sidiz:announcement-dismissed', update);
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  function boot() { var header = document.querySelector('[data-sidiz-header]'); if (header) init(header); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
